import { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

interface ImageElementProps {
  src: string;
  alt: string;
  className?: string;
  scroller?: string;
  style?: any;
  onReady?: () => void;
}

const ImageElement = ({ src, alt, className, scroller, style, onReady }: ImageElementProps) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useGSAP(() => {
    if (!imgRef.current) return;

    gsap.fromTo(
      imgRef.current,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: imgRef.current,
          start: 'top 95%',
          // markers: true,
          scroller: scroller,
        },
      }
    );
  }, []);

  return (
    <img
      ref={imgRef}
      alt={alt}
      className={className}
      style={style}
      src={src}
      onLoad={() => onReady?.()}
    />
  );
};

export default ImageElement;
